var map = {
	"./alliance-retail-group_logo.png": "./src/assets/alliance-retail-group_logo.png",
	"./arg_logo.png": "./src/assets/arg_logo.png",
	"./awg_logo.png": "./src/assets/awg_logo.png",
	"./iPro_logo.png": "./src/assets/iPro_logo.png"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets sync recursive ^\\.\\/.*_logo\\.png$";